angular.module('app')
    .directive('locationSearch', function () {
        return {
            restrict: 'A',
            controller: 'LocationSearchController',
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                options: '=',
                placeSelected: '='
            },
            link: function (scope, elem, attrs, ngModel) {
                scope.vm.element = elem;
                scope.vm.ngModel = ngModel;
                scope.vm.attrs = attrs;
            }
        }
    });